import {useEffect} from "react";
import {useLocation} from "react-router-dom";

const ScrollToTop = () => {
    const {pathname} = useLocation();

    useEffect(() => {
        // Եղած scroll-ը փոխում ենք վերև
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export default ScrollToTop;
